import * as React from 'react'

function ManagementEventsSVG(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16.3928V11.7019C11.6904 11.8264 11.3528 11.8951 11 11.8951C9.51574 11.8951 8.30135 10.6807 8.30135 9.1964C8.30135 7.71214 9.51574 6.49775 11 6.49775C12.4182 6.49775 13.5901 7.6065 13.6915 9H16.3938C16.3874 8.8265 16.3721 8.65517 16.3448 8.49175L17.8666 7.30734C18.0015 7.2024 18.039 7 17.9565 6.85007L16.5172 4.36132C16.4273 4.1964 16.2399 4.14393 16.075 4.1964L14.2834 4.91604C13.9085 4.63118 13.5112 4.3913 13.069 4.21139L12.7991 2.30735C12.7691 2.12744 12.6192 2 12.4393 2H9.56072C9.38081 2 9.23838 2.12744 9.2084 2.30735L8.93853 4.21139C8.49625 4.3913 8.09145 4.63868 7.72414 4.91604L5.93253 4.1964C5.76762 4.13643 5.58021 4.1964 5.49025 4.36132L4.05847 6.85007C3.96852 7.0075 3.9985 7.2024 4.14843 7.30734L5.67016 8.49175C5.63268 8.71664 5.6027 8.96402 5.6027 9.1964C5.6027 9.42878 5.61769 9.67616 5.65517 9.90105L4.13343 11.0855C3.9985 11.1904 3.96102 11.3928 4.04348 11.5427L5.48276 14.0315C5.57271 14.1964 5.76012 14.2489 5.92504 14.1964L7.71664 13.4768C8.09145 13.7616 8.48876 14.0015 8.93103 14.1814L9.2009 16.0855C9.23838 16.2654 9.38081 16.3928 9.56072 16.3928H12Z"
        strokeOpacity="0.54"
        strokeWidth="1.5"
      />
      <path d="M14 11V17.6H15.8V23L20 15.8H17.6L20 11H14Z" fill="currentColor" fillOpacity="0.7" />
    </svg>
  )
}

export default ManagementEventsSVG
